import BG from '~/components/background';
import Form from "../../../../src/events/2020/11/event-subscription/form";
import mainImg from "../../../../src/events/2020/11/event-subscription/images/main.png";
import middleImg from "../../../../src/events/2020/11/event-subscription/images/middle.png";
import * as React from 'react';
export default {
  BG,
  Form,
  mainImg,
  middleImg,
  React
};